export default __webpack_public_path__ + "static/media/frog-nation.946414d5.jpeg";